/* HistoHead size guide (assets/hh-size-guide.js)
   The tabs of every size guide on the page: Inches / Centimeters / Material & Fit. A guide's HTML
   lives in a Shopify page (Online Store → Pages, "Size Guide - …") that holds the table and the
   fit notes only; this file owns the behaviour (the page editor can lose a <script>, never a
   table) and assets/hh-size-guide.css the look. Serves every guide on the page at once (the
   /pages/size-guide accordions) as well as the product page's "Size Guide" pop-up.

   What a guide needs in its page:
     <div class="sizing-container">
       <div class="size-chart-view">
         <table class="size-chart"> … <td class="measure" data-inches="27" data-cm="68.6">27</td> … </table>
         <div class="measure-guide"><img …></div>
       </div>
       <div class="fit-view fit-content"> … </div>
     </div>
   The tab bar (<div class="tabs"> with <button class="tab-btn" data-tab="inches|cm|fit">) is
   optional — built here when missing. data-cm is optional — computed from the inches when missing,
   fractions like "28 ⅘" or "27 1/2" understood. Older guides with onclick="switchSizeGuideTab(…)",
   onclick="switchTab(…)" or id="size-chart-view" / id="fit-view" keep working.
   The visitor's unit is remembered (localStorage); first visit: inches in the US and the UK,
   centimeters elsewhere (Shopify.country).

   The same container also serves a page of named panels — "How Your Bag Is Made" (the tote bag's
   "How it's made" pop-up): Production steps / Size & Features / FAQ. There every tab names its
   panel and every panel carries that name:
     <div class="sizing-container">
       <div class="tabs">
         <button type="button" class="tab-btn" data-tab="steps">Production steps</button> …
       </div>
       <div class="tab-view" data-view="steps" data-title="Production steps"> … </div>
       <div class="tab-view tab-content-box" data-view="specs" data-title="Size &amp; Features"> … </div>
     </div>
   The tab bar is optional here too (built from the panels' data-title). The older markup of that
   page (onclick="switchBagTab(this, 'view-steps')", <div class="bag-view view-steps">) keeps
   working. Named panels have no unit: nothing is remembered, the other guides on the page are
   left alone. */
(function () {
  'use strict';

  var STORE = 'hh:size-unit';
  var UNITS = { inches: 1, cm: 1, fit: 1 };
  var LABELS = { inches: 'Inches', cm: 'Centimeters', fit: 'Material & Fit' };
  var FRACTIONS = {
    '¼': 0.25, '½': 0.5, '¾': 0.75,
    '⅓': 1 / 3, '⅔': 2 / 3,
    '⅕': 0.2, '⅖': 0.4, '⅗': 0.6, '⅘': 0.8,
    '⅙': 1 / 6, '⅚': 5 / 6,
    '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875
  };

  /* "27", "27.5", "28 ⅘", "27 1/2" → a number of inches; anything else → null */
  function parseInches(text) {
    var s = String(text || '').trim();
    var m = s.match(/^(\d+(?:[.,]\d+)?)(?:\s*(?:(\d+)\s*\/\s*(\d+)|([¼½¾⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞])))?$/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(',', '.'));
    if (m[2] && m[3]) n += parseInt(m[2], 10) / parseInt(m[3], 10);
    else if (m[4]) n += FRACTIONS[m[4]];
    return n;
  }

  /* Every number of the text converted to centimeters with one decimal ("27-28" → "68.6-71.1");
     null when a part is not a measurement, so the cell is left as it is */
  function toCm(text) {
    var parts = String(text || '').split(/(\s*[-–]\s*)/);
    var out = [];
    var found = false;
    for (var i = 0; i < parts.length; i++) {
      if (i % 2 === 1) { out.push(parts[i]); continue; }
      var n = parseInches(parts[i]);
      if (n === null) return null;
      out.push((Math.round(n * 25.4) / 10).toFixed(1));
      found = true;
    }
    return found ? out.join('') : null;
  }

  /* The panels of a guide: the size views (inches and cm share .size-chart-view, fit shows
     .fit-view) and the named panels ([data-view]) */
  function panelsOf(container) {
    return container.querySelectorAll('.size-chart-view, .fit-view, [data-view]');
  }

  function panelFor(container, tab) {
    if (tab === 'inches' || tab === 'cm') return container.querySelector('.size-chart-view');
    if (tab === 'fit') return container.querySelector('.fit-view');
    return container.querySelector('[data-view="' + tab + '"]');
  }

  /* A guide of named panels (no size table) */
  function isPanelGuide(container) {
    return !container.querySelector('.size-chart-view') && !!container.querySelector('[data-view]');
  }

  function firstPanelName(container) {
    var first = container.querySelector('[data-view]');
    return first ? first.getAttribute('data-view') : null;
  }

  /* Which tab a button stands for: data-tab, else the older onclick / id, else its label; a button
     of a panel guide without any of these stands for the panel at its own position */
  function tabOf(btn) {
    var t = btn.getAttribute('data-tab');
    if (t) return t;
    var old = (btn.getAttribute('onclick') || '') + ' ' + (btn.id || '');
    var hint = old.match(/['"](inches|cm|fit)['"]|btn-(inches|cm|fit)/);
    if (hint) return hint[1] || hint[2];
    var named = old.match(/['"]view-([\w-]+)['"]/);
    if (named) return named[1];
    var text = (btn.textContent || '').trim().toLowerCase();
    if (/^(cent|cm)/.test(text)) return 'cm';
    if (/^inch/.test(text)) return 'inches';
    var container = btn.closest('.sizing-container');
    if (container && isPanelGuide(container)) {
      var buttons = container.querySelectorAll('.tab-btn');
      var panels = container.querySelectorAll('[data-view]');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i] === btn) return panels[i] ? panels[i].getAttribute('data-view') : firstPanelName(container);
      }
    }
    return 'fit';
  }

  function show(container, tab) {
    var panel = panelFor(container, tab);
    if (!panel) {
      /* a tab without its panel (a size guide without fit notes): the table, else the first panel */
      tab = container.querySelector('.size-chart-view') ? 'inches' : firstPanelName(container);
      if (!tab) return;
      panel = panelFor(container, tab);
    }
    container.setAttribute('data-unit', tab);
    var panels = panelsOf(container);
    for (var p = 0; p < panels.length; p++) {
      panels[p].classList.toggle('active', panels[p] === panel);
      /* the CSS decides which panel shows; an inline display of an older page would overrule it */
      panels[p].style.display = '';
    }
    var buttons = container.querySelectorAll('.tab-btn');
    for (var i = 0; i < buttons.length; i++) {
      var on = tabOf(buttons[i]) === tab;
      buttons[i].classList.toggle('active', on);
      buttons[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    if (tab !== 'inches' && tab !== 'cm') return;
    var cells = container.querySelectorAll('.measure');
    for (var j = 0; j < cells.length; j++) {
      var cell = cells[j];
      var value = cell.getAttribute('data-' + tab);
      if (value === null && tab === 'cm') {
        value = toCm(cell.getAttribute('data-inches'));
        if (value !== null) cell.setAttribute('data-cm', value);
      }
      if (value !== null) cell.textContent = value;
    }
  }

  function remember(unit) {
    if (unit !== 'cm' && unit !== 'inches') return;
    try { localStorage.setItem(STORE, unit); } catch (e) { /* private mode */ }
  }

  function preferredUnit() {
    try {
      var u = localStorage.getItem(STORE);
      if (u === 'cm' || u === 'inches') return u;
    } catch (e) { /* private mode */ }
    var country = (window.Shopify && window.Shopify.country) || '';
    return /^(US|GB|LR|MM)$/.test(country) ? 'inches' : 'cm';
  }

  function makeButton(tab, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tab-btn';
    b.setAttribute('data-tab', tab);
    b.textContent = label;
    return b;
  }

  /* The tab bar when the page has none: Inches / Centimeters (+ Material & Fit) for a size guide,
     one tab per panel (its data-title, else its name) for a panel guide */
  function buildTabs(container) {
    var bar = document.createElement('div');
    bar.className = 'tabs';
    if (isPanelGuide(container)) {
      var panels = container.querySelectorAll('[data-view]');
      for (var p = 0; p < panels.length; p++) {
        var name = panels[p].getAttribute('data-view');
        var title = panels[p].getAttribute('data-title') ||
          name.charAt(0).toUpperCase() + name.slice(1).replace(/[-_]+/g, ' ');
        bar.appendChild(makeButton(name, title));
      }
    } else {
      var units = container.querySelector('.fit-view') ? ['inches', 'cm', 'fit'] : ['inches', 'cm'];
      for (var i = 0; i < units.length; i++) bar.appendChild(makeButton(units[i], LABELS[units[i]]));
    }
    container.insertBefore(bar, container.firstChild);
  }

  /* The tab a panel guide opens on: the button marked active in the page, else the first one */
  function firstTab(container) {
    var marked = container.querySelector('.tab-btn.active') || container.querySelector('.tab-btn');
    return marked ? tabOf(marked) : firstPanelName(container);
  }

  function prepare(container) {
    if (container.hasAttribute('data-hh-ready')) return;
    container.setAttribute('data-hh-ready', '');

    /* older guides name their views by id: give them the classes, so the CSS and the other
       guides on the same page agree (ids repeat on /pages/size-guide) */
    var chartById = container.querySelector('#size-chart-view');
    if (chartById) chartById.classList.add('size-chart-view');
    var fitById = container.querySelector('#fit-view');
    if (fitById) fitById.classList.add('fit-view');

    /* the older markup of the "How Your Bag Is Made" page: <div class="bag-view view-steps"> */
    var olderPanels = container.querySelectorAll('.bag-view');
    for (var o = 0; o < olderPanels.length; o++) {
      var m = olderPanels[o].className.match(/\bview-([\w-]+)/);
      if (m && !olderPanels[o].hasAttribute('data-view')) olderPanels[o].setAttribute('data-view', m[1]);
    }

    var panel = isPanelGuide(container);
    if (!panel && !container.querySelector('.size-chart-view')) {
      /* a page that holds just the table (and the picture): wrap them as the table view */
      var fit = container.querySelector('.fit-view');
      var wrap = document.createElement('div');
      wrap.className = 'size-chart-view';
      var kids = Array.prototype.slice.call(container.childNodes);
      for (var k = 0; k < kids.length; k++) {
        var node = kids[k];
        if (node.nodeType === 1 && (node.classList.contains('tabs') || node === fit)) continue;
        wrap.appendChild(node);
      }
      container.insertBefore(wrap, fit || null);
    }

    /* the number written in the cell is the inches. A cell edited in the page editor keeps its old
       data-inches / data-cm: when they disagree, the text wins and the centimeters are recomputed */
    var cells = container.querySelectorAll('.measure');
    for (var c = 0; c < cells.length; c++) {
      var text = cells[c].textContent.replace(/\s+/g, ' ').trim();
      var kept = (cells[c].getAttribute('data-inches') || '').replace(/\s+/g, ' ').trim();
      if (kept !== text) {
        cells[c].setAttribute('data-inches', text);
        cells[c].removeAttribute('data-cm');
      }
    }

    if (!container.querySelector('.tab-btn')) buildTabs(container);
    if (!panel && container.querySelectorAll('thead th').length > 3) container.classList.add('sizing-container--wide');

    show(container, panel ? firstTab(container) : preferredUnit());
  }

  function prepareAll(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1 && root.classList.contains('sizing-container')) prepare(root);
    var list = root.querySelectorAll('.sizing-container');
    for (var i = 0; i < list.length; i++) prepare(list[i]);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.sizing-container .tab-btn') : null;
    if (!btn) return;
    e.preventDefault();
    var tab = tabOf(btn);
    var own = btn.closest('.sizing-container');
    show(own, tab);
    if (tab !== 'inches' && tab !== 'cm') return;
    remember(tab);
    /* the other size guides on the page follow the unit (they share the visitor's choice) */
    var all = document.querySelectorAll('.sizing-container');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === own || isPanelGuide(all[i])) continue;
      if (all[i].getAttribute('data-unit') !== 'fit') show(all[i], tab);
    }
  });

  /* the inline handlers of older guides, in case their own <script> is gone */
  if (!window.switchSizeGuideTab) window.switchSizeGuideTab = function () {};
  if (!window.switchTab) window.switchTab = function () {};
  if (!window.switchBagTab) window.switchBagTab = function () {};

  function start() {
    prepareAll(document);
    if (!window.MutationObserver) return;
    /* guides that arrive later: the theme editor re-rendering a section, content loaded by script */
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var a = 0; a < added.length; a++) prepareAll(added[a]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
